function observeVisibility(element, callback) {
  var options = {
    root: document.documentElement,
  };

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      callback(entry.intersectionRatio > 0);
    });
  }, options);

  observer.observe(element);
}

function conditionalFileUploadAddOnRequiredWhenVisible() {
	const addToCartForm = document.querySelector('.wp-block-add-to-cart-form');

	if (!addToCartForm) {
		return;
	}

	const imageYesNoAddOns = addToCartForm.querySelectorAll('.wc-pao-addon-container:has(.wc-pao-addon-radio):has(.wc-pao-addon-field[data-label="Ja"]):has(.wc-pao-addon-field[data-label="Nei"]):has(.wc-pao-addon-name[data-addon-name*="ilde"])');

	imageYesNoAddOns.forEach(imageYesNoAddOn => {
		const imageYesNoAddOnFileUpload = imageYesNoAddOn.nextElementSibling;

		if (!imageYesNoAddOnFileUpload.matches('.wc-pao-addon-container:has(.wc-pao-addon-file-upload):has(.wc-pao-addon-name[data-addon-name*="ilde"])')) {
			return;
		}

		const imageYesNoAddOnFileUploadInput = imageYesNoAddOnFileUpload.querySelector('input[type="file"]');

		observeVisibility(imageYesNoAddOnFileUpload, isVisible => {
			if (isVisible) {
				imageYesNoAddOnFileUploadInput.required = true;
			} else {
				imageYesNoAddOnFileUploadInput.required = false;
			}
		});
	});
}

export function init() {
	conditionalFileUploadAddOnRequiredWhenVisible();
}
